<template>
  <cms-shell :data="data" title="Standort" @up="$emit('up', -1, data)" @down="$emit('down', 1, data)" @remove="$emit('remove', data)">
    <div layout="row center-stretch">
      <div>
        Lat
        <input type="text" class="form-control" v-model="data.lat" placeholder="Lat"/>
      </div>
      <div>
        Lng
        <input type="text" class="form-control" v-model="data.lng" placeholder="Lng"/>
      </div>
    </div>

  </cms-shell>
</template>

<script>
  import CmsShell from "./CmsShell";

  export default {
    components: {CmsShell},
    name: "cms-map",
    props: ['data']
  }
</script>

<style scoped>
  input {
    width:95%;
  }
</style>



// WEBPACK FOOTER //
// src/components/cms/CmsLocation.vue